import axios from 'axios'
import router from '../router'
// import { i18n } from './i18n'
import store from '@/store'
// import { MessageBoxAlert } from '@/utils/message-box'

// create an axios instance
const service = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_API}/api/v1`,
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 8000 // request timeout
})

// 设置请求次数，请求的间隙
service.defaults.retry = 3
service.defaults.retryDelay = 5000

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.url === '/pub/auth/refresh-token' && store.state.user.access_token) {
      config.headers['refresh-token'] = `Bearer ${store.state.user.access_token}`
    }
    if (store.getters.token) {
      config.headers.Authorization = `Bearer ${store.getters.token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(response => {
  const { code, data } = response.data
  console.log(data)
  if (code === 2016) {
    return response.data
  }
  if (code !== 1000) {
    // MessageBoxAlert(
    //   'error',
    //   '' // i18n.t(`translation.apiMessageCode.${code}`, data)
    // ).then(() => {
    //   switch (code) {
    //     case 3006:
    //     case 3007:
    //     case 3008:
    //     case 3009:
    //     case 3014:
    //       store.dispatch('user/resetToken').then(() => {
    //         router.push('/login')
    //       })
    //       break
    //     default:
    //       return response.data
    //   }
    // })
    setTimeout(() => {
      const c = document.querySelector('body > div.el-message-box__wrapper > div > div.el-message-box__btns > button')
      if (c) {
        c.click()
      }
    }, 5000)
  }
  return response.data
}, (error) => {
  const { response } = error
  if (response) {
    const { status } = response
    switch (status) {
      case 401:
        router.push({ name: 'Page401' })
        return
    }
    return Promise.reject(error)
  }
  // MessageBoxAlert('error', error.message).then(() => {
  //   return Promise.reject(error)
  // })
})

export default service
